import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import HelpIcon from "../components/svg/HelpIcon"
import {Popover, OverlayTrigger} from 'react-bootstrap'

const InjectMassage = props => {
    const m = props.intl.messages
    const help = m[`${props.id}_help`]
    if(props.raw){
        return m[props.id] || props.id
    }
    return (
        <>
            <FormattedMessage {...props} />
            {
                help && (
                    <OverlayTrigger
                        placement="right"
                        overlay={<Popover id={`pop_${props.id}`}><FormattedMessage {...props} id={`${props.id}_help`} /></Popover>}>
                                    <span data-tip data-for={`pop_${props.id}`} className="hint-universal">
                                      <HelpIcon/>
                                    </span>
                    </OverlayTrigger>
                )
            }
        </>
    )
}

export default injectIntl(InjectMassage, {
    withRef: false
})
